import React from 'react';
import c from 'classnames';
import { useTranslation } from 'react-i18next';
import DeviationFlag from '@wix/da-ds/pkg/Indicators/DeviationFlag';
import ThumbStatusIndicators from '@wix/da-ds/pkg/thumbs/ThumbStatusIndicators';
import SimpleTooltip from '@wix/da-ds/pkg/tooltips/dsPreset/SimpleTooltip';
import DeviationThumbDiscountLabel from '../DeviationThumbDiscountLabel';
import { useOverlayContext } from '../../../hooks/useOverlayContext';
import { getIsUserSubscribed, isHyped } from '../../../_helpers';
import { useIsCurrentUserDeviationAuthor } from '../../../../utils/hooks/useIsCurrentUserDeviationAuthor';
import { normalizePremiumFolderData } from '../../../../utils/normalizePremiumFolderData';
import { getIsAdopted, getIsOnSale, getIsPending } from '../../../../utils/adoptables';
import s from './DeviationThumbIndicators.scss';
export var AllowedIndicators = /*#__PURE__*/ function(AllowedIndicators) {
    AllowedIndicators["Flag"] = "flag";
    AllowedIndicators["Status"] = "status";
    AllowedIndicators["Discount"] = "discount";
    AllowedIndicators["All"] = "all";
    AllowedIndicators["None"] = "none";
    return AllowedIndicators;
}({});
function getIndicators(deviation) {
    const indicators = [];
    if (deviation.primaryTier) {
        indicators.push('in-tier');
    }
    const { isPaidFolder } = normalizePremiumFolderData(deviation.premiumFolderData);
    if (isPaidFolder) {
        indicators.push('premium-folder');
    }
    if (deviation.commission) {
        indicators.push('commission');
    }
    if (deviation.isAdoptable && (getIsOnSale(deviation) || getIsPending(deviation) || getIsAdopted(deviation))) {
        indicators.push('adoptable');
    }
    return indicators;
}
const DeviationThumbIndicators = ({ className, deviation, allowedIndicators = "all" })=>{
    var _getIndicators;
    const { t } = useTranslation();
    const { showDailyDeviationLabel, showHypeLabel, showStashLabel, showThumbStatusIndicators } = useOverlayContext(deviation);
    const isOwner = useIsCurrentUserDeviationAuthor(deviation);
    const allowFlags = allowedIndicators === "flag" || allowedIndicators === "all";
    const allowStatusIndicators = allowedIndicators === "status" || allowedIndicators === "all";
    const allowDiscountIndicators = allowedIndicators === "discount" || allowedIndicators === "all";
    const showDailyDeviation = allowFlags && deviation.isDailyDeviation && showDailyDeviationLabel;
    const showHype = allowFlags && showHypeLabel && isHyped(deviation);
    const showStash = allowFlags && showStashLabel && !deviation.isPublished;
    const statusIndicators = showThumbStatusIndicators && allowStatusIndicators ? (_getIndicators = getIndicators(deviation)) === null || _getIndicators === void 0 ? void 0 : _getIndicators.slice(0, showDailyDeviation ? 2 : 3) : [];
    return /*#__PURE__*/ React.createElement("div", {
        className: c(s['root'], className)
    }, showDailyDeviation && /*#__PURE__*/ React.createElement(SimpleTooltip, {
        text: t('thumb.tooltip.dailyDeviation'),
        usePortal: true
    }, /*#__PURE__*/ React.createElement(DeviationFlag, {
        variant: "daily-deviation",
        size: "large",
        className: s['dd']
    })), showHype && /*#__PURE__*/ React.createElement(DeviationFlag, {
        variant: "hype",
        size: "large",
        className: s['hype']
    }), showStash && /*#__PURE__*/ React.createElement(DeviationFlag, {
        variant: "stash",
        size: "large",
        className: s['stash']
    }), /*#__PURE__*/ React.createElement(ThumbStatusIndicators, {
        indicators: statusIndicators.map((type)=>({
                type,
                tooltip: t(`thumb.tooltip.${type}`),
                hasAccess: getIsUserSubscribed(deviation) || isOwner
            }))
    }), allowDiscountIndicators && /*#__PURE__*/ React.createElement(DeviationThumbDiscountLabel, {
        className: s['discount'],
        deviation: deviation
    }));
};
DeviationThumbIndicators.displayName = 'DeviationThumbIndicators';
export default DeviationThumbIndicators;

//# sourceMappingURL=DeviationThumbIndicators.js.map